import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import SolutionPage from "./pages/SolutionPage";
import FeaturePage from "./pages/FeaturePage";
import ResourcesPage from "./pages/ResourcesPage";
import AgencyBlueprintPage from "./pages/AgencyBlueprintPage";
import EnterpriseGeoGuidePage from "./pages/EnterpriseGeoGuidePage";
import ContactPage from "./pages/ContactPage";
import ImprintPage from "./pages/ImprintPage";
import PrivacyPage from "./pages/PrivacyPage";
import AboutPage from "./pages/AboutPage";
import NotFound from "./pages/NotFound";
import MittelstandPage from "./pages/MittelstandPage";
import CookieConsent from "./components/CookieConsent";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>

          <Route path="/" element={<Index />} />
          <Route path="/maschinenbau" element={<MittelstandPage />} />
          <Route path="/solutions/:slug" element={<SolutionPage />} />
          <Route path="/platform/:slug" element={<FeaturePage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/agency-blueprint" element={<AgencyBlueprintPage />} />
          <Route path="/resources/enterprise-geo-guide" element={<EnterpriseGeoGuidePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/imprint" element={<ImprintPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/about" element={<AboutPage />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <CookieConsent />
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
